<template>
  <div class="d-flex mb-2 draw">
    <div class="d-none d-md-block me-3 ms-3" title="Ramener toutes les lettres">
      <img src="/static/next-alt.svg" v-on:click="clearBoard" class="icon"/>
    </div>
    <div class="flex-grow-1 position-relative">
      <div class="drawLetters d-flex"
        v-on:dragenter="$event.preventDefault()"
        v-on:drop="drop"
        v-on:dragover="dragstarted = true"
        ref="drawarea">
        <div
        v-for="(tile, index) in draw"
        v-bind:key="`${tile.drawIndex}${tile.tile.value}`"
        v-bind:class="tileContainerClass(index)">
          <Tile
          v-bind:droppedTile="tile"
          v-bind:draggable="true"
          v-bind:roundNumber="roundNumber"
          ref="tiles"
          v-on:dragstart="dragstarted = true"
          v-on:open-letter-selection="openLetterSelection">
          </Tile>
        </div>
      </div>
      <div v-if="dragstarted" class="putover"
        v-on:dragenter="$event.preventDefault()"
        v-on:dragover="dragover"
        v-on:dragleave="dragLeave"
        v-on:mousedown="dragstarted = false"
        v-on:click="dragstarted = false"
        v-on:drop="drop">
      </div>
    </div>
    <div class="me-3 ms-3" title="Mélanger les lettres">
      <img src="/static/shuffle.svg" v-on:click="shuffle" class="icon"/>
    </div>

  </div>
</template>

<script>
import Tile from './Tile.vue';

export default {
  name: 'GameDraw',
  emits: ['tile-moved', 'open-letter-selection', 'clear-board', 'shuffle-draw'],
  props: {
    draw: {
      type: Array,
      required: true,
    },
    roundNumber: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pushIndex: 7,
      dragstarted: false,
    };
  },
  watch: {
    // le chevalet est modifié en place (splice) par la partie : on surveille aussi ses éléments,
    // comme le faisait Vue 2 pour un tableau
    draw: {
      handler() {
        this.dragstarted = false;
      },
      deep: 1,
    },
  },
  components: { Tile },
  methods: {
    drop(event) {
      event.preventDefault();
      const message = JSON.parse(event.dataTransfer.getData('text/plain'));
      message.to = 'DrawSquare';
      const left = event.clientX - this.$refs.drawarea.getBoundingClientRect().left;
      const tileDraging = this.$refs.tiles.find(t => t.draging);
      const draginIndex = tileDraging ? tileDraging.droppedTile.drawIndex : -1;
      const index = Math.floor(left / 40);
      message.drawIndex = draginIndex < 0 || index < draginIndex ? index : index + 1;
      this.pushIndex = 7;
      this.$emit('tile-moved', message);
    },
    tileDropped(message) {
      this.$emit('tile-moved', message);
    },
    openLetterSelection(tile) {
      this.$emit('open-letter-selection', tile);
    },
    clearBoard() {
      this.$emit('clear-board');
    },
    shuffle() {
      this.$emit('shuffle-draw');
    },
    dragover(event) {
      event.preventDefault();
      const left = event.clientX - this.$refs.drawarea.getBoundingClientRect().left;
      const tileDraging = this.$refs.tiles.find(t => t.draging);
      const draginIndex = tileDraging ? tileDraging.droppedTile.drawIndex : -1;
      const index = Math.floor(left / 40);
      this.pushIndex = draginIndex < 0 || index < draginIndex ? index : index + 1;
    },
    dragLeave() {
      this.pushIndex = 7;
      this.dragstarted = false;
    },
    dragstart() {
    },
    tileContainerClass(index) {
      return {
        'tile-container': true,
        'd-flex': true,
        'flex-column': true,
        'align-items-end': true,
        pushed: index === this.pushIndex,
      };
    },
  },
};
</script>

<style scoped>
img:hover{
  cursor: pointer;
}

img.icon {
  width: 16px;
}

.draw *{
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.draw {
  position: relative;
}

.drawLetters{
  background: rgb(75,105,106);
  background: linear-gradient(34deg, rgba(75,105,106,1) 0%, rgba(107,187,174,1) 100%);
  min-width: 200px;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 30px;
  padding-right: 30px;
}

.tile{
  width: 19px;
}
.tile-container .tile{
  margin: 0 2px;
}

@media (min-width: 992px) {
  .drawLetters{
    min-width: 330px;
    height: 46px;
  }

  img.icon {
    padding-top: 8px;
    width: 30px;
  }

  .tile{
    margin: 0px;
    width: 38px;
    height: 38px;
  }

  .move-on-drag-over .tile-container{
    margin-left: 22px;
  }

  .tile-container.pushed .tile {
    margin-left: 40px;
  }

  .putover {
    position: absolute;
    height: 46px;
    top: 0;
    width: 100%;
  }
}
</style>
